import { TimeFrameUnit } from './TimeFrameUnit';
import libPluralize from 'pluralize';

const pluralize = (word: string, count: number) => libPluralize(word, count);

const relativeDateLabelFormatters: Record<
  TimeFrameUnit,
  (count: number) => string
> = {
  [TimeFrameUnit.HOUR_AGO]: count => `${pluralize('Hour', count)} ago`,
  [TimeFrameUnit.DAY_AGO]: count => `${pluralize('Day', count)} ago`,
  [TimeFrameUnit.MONTH_AGO]: count => `${pluralize('Month', count)} ago`,
  [TimeFrameUnit.YEAR_AGO]: count => `${pluralize('Year', count)} ago`,
  [TimeFrameUnit.DAY_FROM_NOW]: count => `${pluralize('Day', count)} from now`,
  [TimeFrameUnit.MONTH_FROM_NOW]: count =>
    `${pluralize('Month', count)} from now`,
  [TimeFrameUnit.YEAR_FROM_NOW]: count =>
    `${pluralize('Year', count)} from now`,
  [TimeFrameUnit.HOUR_FROM_NOW]: count =>
    `${pluralize('Hour', count)} from now`,
};

export { relativeDateLabelFormatters };
